export default {"src":"/_next/static/media/homeFooter.7d36fa23.svg","height":781,"width":1920,"blurWidth":0,"blurHeight":0};